import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { AboutSubscription } from 'containers/VideoInfo/SvodInfo';
import _ from 'lodash';
import { PATH } from 'types/router';
import playSprite from 'assets/icons/play.svg';

import {
  SvodAndDtoOrTvodButtonsStyled,
  TwoButtonsWrap,
  ColumnWrap,
  StyledButton,
} from './styles/SvodAndDtoOrTvodButtonsStyled';

const SvodAndDtoOrTvodButtons = ({
  isAvailable,
  hasTVOD,
  hasDTO,
  goTo,
  translate,
  subscriptionInfo,
  isTnB,
  minPrice,
  geo,
  buyingTariffs,
  isMobile,
}) => {
  let buyMovieType;
  let buyMovieText = '';
  if (hasTVOD && hasDTO) {
    buyMovieType = 'choose';
  } else if (hasTVOD) {
    buyMovieType = 'rent';
    buyMovieText =
      _.get(buyingTariffs, 'tvod', []).length > 1 ? translate('from') : translate('for');
  } else if (hasDTO) {
    buyMovieType = 'buy';
    buyMovieText =
      _.get(buyingTariffs, 'dto', []).length > 1 ? translate('from') : translate('for');
  }
  return (
    <SvodAndDtoOrTvodButtonsStyled>
      {isAvailable && (
        <Button
          buttonStyle="background"
          textSize="xs"
          size="l"
          align="center"
          textColor="white"
          onClick={() => goTo(PATH.PLAYER)}
          text={translate('watch')}
          icon={playSprite.id}
          iconSize={12}
          isMobile={isMobile}
        />
      )}
      {!isAvailable && (
        <ColumnWrap>
          <TwoButtonsWrap>
            <StyledButton
              onClick={() => goTo(PATH.SUBSCRIPTION_TARIFF_SELECT)}
              text={isTnB ? translate('try') : translate('by_subscription')}
              expandedTextPrice={
                isTnB
                  ? translate('for_price', {
                      price: _.get(subscriptionInfo, 'tariffs.0.priceText'),
                    })
                  : ''
              }
              buttonStyle="background"
              textSize="xs"
              size="s"
              align="center"
              textColor="white"
              isMobile={isMobile}
            />
            <Button
              onClick={() => goTo(PATH.MOVIE_TARIFF_SELECT, { type: buyMovieType })}
              text={translate('buy')}
              expandedTextPrice={`${buyMovieText} ${minPrice}`}
              buttonStyle="background"
              textSize="xs"
              size="s"
              align="center"
              textColor="white"
              isMobile={isMobile}
            />
          </TwoButtonsWrap>
          {isTnB && (
            <AboutSubscription
              translate={translate}
              subscriptionInfo={subscriptionInfo}
              geo={geo}
            />
          )}
        </ColumnWrap>
      )}
    </SvodAndDtoOrTvodButtonsStyled>
  );
};

SvodAndDtoOrTvodButtons.propTypes = {
  hasTVOD: PropTypes.bool.isRequired,
  hasDTO: PropTypes.bool.isRequired,
  isAvailable: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  subscriptionInfo: PropTypes.object.isRequired,
  isTnB: PropTypes.bool.isRequired,
  minPrice: PropTypes.string.isRequired,
  geo: PropTypes.string.isRequired,
  buyingTariffs: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
};

SvodAndDtoOrTvodButtons.defaultProps = {
  isMobile: false,
};

export default SvodAndDtoOrTvodButtons;
